import { SalesforceConfigurationType } from './ai';

// Salesforce configurations
export const PATH_ASSISTANT = 'PathAssistant';
export const VALIDATION_RULE = 'ValidationRule';
export const APPROVAL_PROCESS = 'ApprovalProcess';
export const WORKFLOW_RULE = 'WorkflowRule';
export const FLOW = 'Flow';
export const APEX_CLASS = 'ApexClass';
export const PATH = 'Path';
export const FIELD = 'Field';
export const PROCESS_BUILDER_FLOW = 'ProcessBuilderFlow';
export const LAYOUT = 'Layout';
export const APEX_TRIGGER = 'ApexTrigger';

export enum ConfigurationType {
  validationRules = 'validationRules',
  approvalProcesses = 'approvalProcesses',
  workflowRules = 'workflowRules',
  flows = 'flows',
  processBuilderFlows = 'processBuilderFlows',
  apexTriggers = 'apexTriggers',
  apexClasses = 'apexClasses',
  fields = 'fields',
  reports = 'reports',
  layouts = 'layouts',
  emailTemplates = 'emailTemplates',
  objects = 'objects',
  sweepAutomation = 'automations',
  sweepAlert = 'alerts',
  sweepDedupe = 'dedup',
  sweepMatching = 'matching',
  sweepAssignment = 'assignments',
  sweepScheduledAssignment = 'scheduledAssignments',
  rollups = 'rollups',
  cpqData = 'cpqData',
  recordTypes = 'recordTypes',
  paths = 'paths',
  relatedObjects = 'relatedObjects',
  others = 'others',
}

export enum OpenAIConfigurationKeys {
  VALIDATION_RULES = 'validationRules',
  APPROVAL_PROCESSES = 'approvalProcesses',
  WORKFLOW_RULES = 'workflowRules',
  PROCESS_BUILDER_FLOWS = 'processBuilderFlows',
  FLOWS = 'flows',
  LAYOUTS = 'layouts',
  APEX_TRIGGERS = 'apexTriggers',
  APEX_CLASSES = 'apexClasses',
  CPQ_DATA = 'cpqData',
}

export const configurationKeyToType: {
  [key in Exclude<
    OpenAIConfigurationKeys,
    OpenAIConfigurationKeys.CPQ_DATA
  >]: SalesforceConfigurationType;
} = {
  [OpenAIConfigurationKeys.VALIDATION_RULES]: VALIDATION_RULE,
  [OpenAIConfigurationKeys.APPROVAL_PROCESSES]: APPROVAL_PROCESS,
  [OpenAIConfigurationKeys.WORKFLOW_RULES]: WORKFLOW_RULE,
  [OpenAIConfigurationKeys.PROCESS_BUILDER_FLOWS]: FLOW,
  [OpenAIConfigurationKeys.FLOWS]: FLOW,
  [OpenAIConfigurationKeys.LAYOUTS]: LAYOUT,
  [OpenAIConfigurationKeys.APEX_TRIGGERS]: APEX_TRIGGER,
  [OpenAIConfigurationKeys.APEX_CLASSES]: APEX_CLASS,
} as const;
